import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from '../components/LegalPageLayout';

const Disclosures = () => (
  <LegalPageLayout
    title="Disclosures"
    subtitle="Important product, deposit, lending, and regulatory disclosures."
  >
    <p>
      The following disclosures summarize important information about Aurora Wealth Reserves products and services.
      Product-specific agreements, fee schedules, and Truth-in-Lending / Truth-in-Savings documents provided at
      account opening or application control if they differ from this overview.
    </p>

    <h2>Deposit Accounts</h2>
    <ul>
      <li>
        Deposit products may be offered subject to eligibility, identity verification, and approval.
      </li>
      <li>
        Interest rates, APY, fees, and balance requirements vary by product and may change. Current details are
        provided in account disclosures at opening and upon request.
      </li>
      <li>
        Funds availability follows our funds-availability policy and applicable banking regulations.
      </li>
    </ul>

    <h2>FDIC Insurance</h2>
    <p>
      Where indicated, eligible deposit accounts are insured by the Federal Deposit Insurance Corporation (FDIC)
      up to applicable limits. Not all products (for example, certain investment offerings) are FDIC insured.
      Ask a representative which balances and products are covered.
    </p>

    <h2>Lending Products</h2>
    <ul>
      <li>All loans are subject to credit approval and underwriting.</li>
      <li>Rates, terms, and fees depend on creditworthiness, collateral, and product type.</li>
      <li>
        Equal Housing Lender. We do not discriminate on a prohibited basis in any aspect of a credit transaction.
      </li>
      <li>NMLS ID referenced on our site is provided for licensing transparency where applicable.</li>
    </ul>

    <h2>Investments &amp; Non-Deposit Products</h2>
    <p>
      Investment and wealth-management products, where offered, are <strong>not</strong> FDIC insured,
      are not bank deposits or obligations, and may lose value. Past performance does not guarantee future results.
      Educational content on this site is not personalized investment advice.
    </p>

    <h2>Electronic Banking</h2>
    <p>
      Electronic fund transfers are subject to the Electronic Fund Transfer Act disclosures provided with your
      account. Report unauthorized transfers promptly as described in those disclosures and our{' '}
      <Link to="/security">Security Center</Link>.
    </p>

    <h2>Privacy &amp; Terms</h2>
    <p>
      Please also review our <Link to="/privacy">Privacy Policy</Link> and{' '}
      <Link to="/terms">Terms of Service</Link>.
    </p>

    <h2>Questions</h2>
    <p>
      For disclosure documents or clarification, contact{' '}
      <a href="mailto:support@aurorawealthreserves.com">support@aurorawealthreserves.com</a>{' '}
      or use our <Link to="/contact">Contact</Link> page.
    </p>
  </LegalPageLayout>
);

export default Disclosures;
